import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import CurrencyInput from "../CurrencyInput/CurrencyInput";
import numeral from "numeral";

class RefundForm extends React.Component{
  constructor(props){
    super(props);
  };

  render(){
    return (
      <div className="EditPaymentForms">
        <div className="container">
          <div className="panel panel-default">
            <div className="panel-body container">
              <h3 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 20, marginTop: 5, marginBottom: 10 }}>{I18n.t('refund')}</h3>
                {this.renderRefundForm()}
            </div>
          </div>
        </div>
        <LoadingSpinner show={this.props.loading} />
      </div>
    );
  };

  renderRefundForm = () => {

    if (this.props.paymentLogVoucher) {
      return (
        <div className="row ">
          {this.renderVoucherMaxRefund()}
          {this.renderVoucherRefundAmount()}
        </div>  
      );
    } else {
      return (
        <div className="row ">
          {this.renderFolioBalance()}
          {this.renderMaxRefundAmount()}
          {this.renderRefundAmount()}
        </div>
      );
    };

  };

  renderFolioBalance() {
    return (
      <div className="col-sm refund-lead-column">
        <label style={{ marginBottom: '10px' }}>{I18n.t('folio_balance')}</label>
        <div>{this.formatCurrency(this.props.folioBalance)}</div>
      </div>
    );
  };

  renderMaxRefundAmount() {
    return (
      <div className="col-sm">
        <label style={{ marginBottom: '10px' }}>{I18n.t('max_refund')}</label>
        <div>{this.formatCurrency(this.props.paymentLogFolio.paid_to_folio + this.props.paymentLogFolio.refunded_to_folio)}</div>
      </div>
    );
  };

  renderRefundAmount() {
    return (
      <div className="col-sm">
        <label style={{ marginBottom: '10px' }}>{I18n.t('refund')}</label>
        <CurrencyInput
          name='amount' className="form-control"
          data-min-length="0"
          onChange={this.props.onChangeRefundAmount}
          min={0}
          max={this.props.paymentLogFolio.paid_to_folio + this.props.paymentLogFolio.refunded_to_folio}
          value={this.props.refundAmount ? this.props.refundAmount : ''}
        />
      </div>
    );
  };

  renderVoucherMaxRefund = () => {
    return (
      <div className="col-sm">
        <label style={{ marginBottom: '10px' }}>{I18n.t('max_refund')}</label>
        <div>{this.formatCurrency(this.props.paymentTotal - this.props.previouslyRefundedToPayment)}</div>
      </div>
    );
  };

  renderVoucherRefundAmount() {
    return (
      <div className="col-sm">
        <label style={{ marginBottom: '10px' }}>{I18n.t('refund')}</label>
        <CurrencyInput
          name='amount' className="form-control"
          data-min-length="0"
          onChange={this.props.onChangeRefundAmount}
          min={0}
          max={this.props.paymentTotal - this.props.previouslyRefundedToPayment}
          value={this.props.refundAmount ? this.props.refundAmount : ''}
        />
      </div>
    );
  };

  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

};

export default RefundForm